import { render, staticRenderFns } from "./ZendeskReport.vue?vue&type=template&id=31e048c0&"
import script from "./ZendeskReport.vue?vue&type=script&lang=js&"
export * from "./ZendeskReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports